// @ts-nocheck
(function () {
  if (window.__sonnoPdpPaymentDetailsInit) return;
  window.__sonnoPdpPaymentDetailsInit = true;

  const DIVIDEBUY_DRAWER_PREFIX = 'sonno-dividebuy-drawer-';
  const TEMPLATE_NAME = window._template && typeof window._template.name === 'string' ? window._template.name : '';
  const IS_PRODUCT_TEMPLATE = TEMPLATE_NAME === 'product';

  function parsePoundsFromText(text) {
    const raw = String(text || '')
      .replace(/\u00a0/g, ' ')
      .trim();

    // Matches "£359.99" or "359.99"
    const match = raw.match(/£\s*([\d,]+\.?\d*)/i) || raw.match(/([\d,]+\.?\d*)/);
    if (!match) return null;

    const num = parseFloat(String(match[1]).replace(/,/g, ''));
    return Number.isFinite(num) ? num : null;
  }

  function round2(num) {
    const n = Number(num);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * 100) / 100;
  }

  function formatPounds(num) {
    const n = Number(num);
    if (!Number.isFinite(n)) return '£0.00';
    return '£' + n.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function getTotalFromPaymentDetailsDataset() {
    const el = document.querySelector('[data-sonno-payment-details]');
    if (!el) return null;
    const raw = el.getAttribute('data-sonno-payment-total-cents');
    const cents = parseInt(String(raw || ''), 10);
    if (!Number.isFinite(cents)) return null;
    return cents / 100;
  }

  function setPaymentDetailsTotalCents(cents) {
    try {
      const safe = typeof cents === 'number' && Number.isFinite(cents) ? Math.max(0, Math.round(cents)) : 0;
      document.querySelectorAll('[data-sonno-payment-details]').forEach((el) => {
        el.setAttribute('data-sonno-payment-total-cents', String(safe));
      });
    } catch (_e) {}
  }

  function getCartJsUrl() {
    try {
      const root = window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';
      const base = root.endsWith('/') ? root : `${root}/`;
      return `${base}cart.js`;
    } catch (_e) {
      return '/cart.js';
    }
  }

  async function fetchCartTotalPounds() {
    const url = getCartJsUrl();
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    const cart = await res.json();
    const cents = cart && typeof cart.total_price === 'number' ? cart.total_price : null;
    if (cents === null) return null;
    setPaymentDetailsTotalCents(cents);
    return cents / 100;
  }

  function getCurrentTotalPounds() {
    // Cart/sidebar can provide the current total via data attribute.
    const fromDataset = getTotalFromPaymentDetailsDataset();
    if (fromDataset !== null) return fromDataset;

    // Prefer the current displayed price (already includes add-ons per PDP logic)
    const candidates = Array.from(document.querySelectorAll('#currentPrice'));
    for (const el of candidates) {
      const val = parsePoundsFromText(el.textContent);
      if (val !== null) return val;
    }

    // Fallback: compute from pdpState if available
    const state = window.pdpState || {};
    const variantCents = state && state._lastVariant && typeof state._lastVariant.price === 'number' ? state._lastVariant.price : null;
    if (variantCents === null) return null;

    const baseAddonPounds = parseFloat(state.basePrice || 0) || 0;
    const mattressAddonPounds = parseFloat(state.mattressAddonPrice || 0) || 0;
    const assemblyAddonPounds = parseFloat(state.assemblyAddonPrice || 0) || 0;
    const removeBedAddonPounds = parseFloat(state.removeBedAddonPrice || 0) || 0;
    const removeMattressAddonPounds = parseFloat(state.removeMattressAddonPrice || 0) || 0;
    const roomOfChoiceAddonPounds = parseFloat(state.roomOfChoiceDeliveryAddonPrice || 0) || 0;

    const totalCents =
      (variantCents || 0) +
      Math.round(baseAddonPounds * 100) +
      Math.round(mattressAddonPounds * 100) +
      Math.round((assemblyAddonPounds + removeBedAddonPounds + removeMattressAddonPounds + roomOfChoiceAddonPounds) * 100);

    return totalCents / 100;
  }

  function calculateKlarnaMonthly(totalPounds) {
    return round2(totalPounds / 3);
  }

  function calculateDivideBuy(totalPounds) {
    const totalFormatted = formatPounds(totalPounds);
    const calculations = [
      { month: 6, total: totalFormatted, isLimit: false, calculatedAmount: 0, limitAmount: 100 },
      { month: 8, total: totalFormatted, isLimit: false, calculatedAmount: 0, limitAmount: 160 },
      { month: 10, total: totalFormatted, isLimit: false, calculatedAmount: 0, limitAmount: 500 },
      { month: 12, total: totalFormatted, isLimit: false, calculatedAmount: 0, limitAmount: 600 },
    ];

    let currentCalculated = 0;

    if (totalPounds > 100) {
      const v = round2(totalPounds / 6);
      calculations[0].calculatedAmount = v;
      calculations[0].isLimit = true;
      currentCalculated = v;
    }

    if (totalPounds > 160) {
      const v = round2(totalPounds / 8);
      calculations[1].calculatedAmount = v;
      calculations[1].isLimit = true;
      currentCalculated = v;
    }

    if (totalPounds > 500) {
      const v = round2(totalPounds / 10);
      calculations[2].calculatedAmount = v;
      calculations[2].isLimit = true;
      currentCalculated = v;
    }

    if (totalPounds > 600) {
      const v = round2(totalPounds / 12);
      calculations[3].calculatedAmount = v;
      calculations[3].isLimit = true;
      currentCalculated = v;
    }

    return { calculations, currentCalculated };
  }

  function renderDivideBuyTable(calculations) {
    const bodies = document.querySelectorAll('[data-sonno-dividebuy-table-body]');
    bodies.forEach((tbody) => {
      tbody.innerHTML = '';

      calculations.forEach((row) => {
        const tr = document.createElement('tr');
        tr.className = 'dimension-row fw-medium w-full';
        tr.style.fontSize = 'var(--gap-sm)';
        tr.style.gridTemplateColumns = 'repeat(4, 1fr)';
        if (!row.isLimit) {
          tr.style.opacity = '0.45';
        }

        const tdMonths = document.createElement('td');
        tdMonths.textContent = String(row.month);
        tdMonths.className = 'flex justify-center item-center flex-col text-center';
        tdMonths.style.color = '#1e3851'

        const tdTotal = document.createElement('td');
        tdTotal.className = 'flex justify-center item-center flex-col text-center';
        tdTotal.style.color = '#1e3851'
        if (row.isLimit) {
          tdTotal.textContent = row.total;
        } else {
          tdTotal.innerHTML = `<div>Only available above</div><div>£ ${row.limitAmount}</div>`;
        }
        
        const tdApr = document.createElement('td');
        tdApr.className = 'flex justify-center item-center flex-col text-center';
        tdApr.style.color = '#1e3851'
        tdApr.textContent = '0.00%';
        
        const tdMonthly = document.createElement('td');
        tdMonthly.className = 'flex justify-center item-center flex-col text-center';
        tdMonthly.style.color = '#3589da'
        tdMonthly.textContent = `£ ${row.calculatedAmount}`;

        tr.appendChild(tdMonths);
        tr.appendChild(tdTotal);
        tr.appendChild(tdApr);
        tr.appendChild(tdMonthly);

        tbody.appendChild(tr);
      });
    });
  }

  function updatePaymentDetails() {
    const total = getCurrentTotalPounds();
    if (!Number.isFinite(total) || total === null) return;

    // Klarna: just update the monthly price (no modal)
    const klarnaMonthly = formatPounds(calculateKlarnaMonthly(total));
    document.querySelectorAll('[data-sonno-klarna-monthly]').forEach((el) => {
      el.textContent = klarnaMonthly;
    });

    // DivideBuy: compute summary + table rows
    const { calculations, currentCalculated } = calculateDivideBuy(total);
    const divideBuyMonthly = formatPounds(currentCalculated);
    document.querySelectorAll('[data-sonno-dividebuy-monthly]').forEach((el) => {
      el.textContent = divideBuyMonthly;
    });

    renderDivideBuyTable(calculations);
  }

  function onDrawerOpened(e) {
    const drawerId = e && e.detail ? e.detail.drawerId : '';
    if (!drawerId || !String(drawerId).startsWith(DIVIDEBUY_DRAWER_PREFIX)) return;
    updatePaymentDetails();
  }

  function observeDisplayedPrice() {
    const el = document.querySelector('#currentPrice');
    if (!el || el.__sonnoObserved === true) return;
    el.__sonnoObserved = true;

    const observer = new MutationObserver(() => {
      updatePaymentDetails();
    });

    observer.observe(el, { characterData: true, childList: true, subtree: true });
  }

  window.addEventListener('sonno:pdpStateChanged', updatePaymentDetails);
  window.addEventListener('sonno:drawerOpened', onDrawerOpened);

  // Cart realtime updates (DO NOT run on product pages; PDP should use product price).
  if (!IS_PRODUCT_TEMPLATE) {
    window.addEventListener('sonno:cartUpdated', (e) => {
      try {
        const cart = e && e.detail ? e.detail.cart : null;
        if (cart && typeof cart.total_price === 'number') {
          setPaymentDetailsTotalCents(cart.total_price);
          updatePaymentDetails();
        }
      } catch (_e) {}
    });

    window.addEventListener('sonno:cartRefreshed', () => {
      fetchCartTotalPounds()
        .then(() => updatePaymentDetails())
        .catch(() => updatePaymentDetails());
    });

    window.addEventListener('sonno:cartUiReady', () => {
      fetchCartTotalPounds()
        .then(() => updatePaymentDetails())
        .catch(() => updatePaymentDetails());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observeDisplayedPrice();
      // On PDP: do NOT fetch cart totals; use product price (like before).
      // On cart pages: ensure we have a cart total.
      if (IS_PRODUCT_TEMPLATE) {
        updatePaymentDetails();
      } else {
        fetchCartTotalPounds()
          .then(() => updatePaymentDetails())
          .catch(() => updatePaymentDetails());
      }

      // Also watch for the widget being injected later (sidebar/drawer).
      try {
        const mo = new MutationObserver(() => {
          if (!document.querySelector('[data-sonno-payment-details]')) return;
          mo.disconnect();
          if (IS_PRODUCT_TEMPLATE) {
            updatePaymentDetails();
          } else {
            fetchCartTotalPounds()
              .then(() => updatePaymentDetails())
              .catch(() => updatePaymentDetails());
          }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
      } catch (_e) {}
    });
  } else {
    observeDisplayedPrice();
    if (IS_PRODUCT_TEMPLATE) {
      updatePaymentDetails();
    } else {
      fetchCartTotalPounds()
        .then(() => updatePaymentDetails())
        .catch(() => updatePaymentDetails());
    }
  }
})();
